export default __webpack_public_path__ + "static/media/customer_segmentation.011bc377.PNG";